export default [
  {
    q: 'Does your company look at or share my data',
    a: 'All your data stays in your Google account (Google Sheets) and never resides on our servers.',
  },
  {
    q: 'Is your Google add-on GDPR compliant?',
    a: "Per GDPR, Digital Inspiration is a Data Controller for individuals using it. All of your add-on data resides in your Google Sheets though. Our add-on only acts on this data, and doesn't store any of it itself. The add-on can be uninstalled by the user at any time, with all data remaining in the users' Google account afterwards.",
  },
];
